import EquityMarket from 'modules/trading/pages/EquityMarket';
import { EquityMarketProvider } from '../contexts/EquityMarketContext';

const EquityMarketContainer = () => (
  <EquityMarketProvider>
    <EquityMarket />
  </EquityMarketProvider>
);

export default EquityMarketContainer;
